<main @fade>
  <nb-card [nbSpinner]="loading">
    <nb-card-body>
      <app-create-update-form [base]="this">
        <p *ngIf="shareUrl">
          <a (click)="copyShareUrl()" i18n-nbTooltip="@@Copy" nbTooltip="Скопировать" style="cursor:pointer">
            <nb-icon icon="copy-outline"></nb-icon>
            {{ shareUrl }} </a>
        </p>

      </app-create-update-form>
    </nb-card-body>
  </nb-card>
</main>
